import { required, obj, array } from 'AppReact/schema';

export const credentials = {
  name: required('string'),
  value: required('string')
}

export const partner = {
  id: required('integer'),
  description: required('string'),
  provider: required('string'),
  credentials: array(obj(credentials))
}